<template>
  <div class="col-md-12 px-gap">
    <div
      class="list-source bg-white p-l-20 p-r-20 p-t-20 p-b-20 rounded shade"
      id="countSource"
    >
      <div class="row">
        <div class="col-md-3">
          <h5 class="no-margin">Media Konvensional</h5>
          <loader-component v-if="isloading" />
          <div v-else>
            <div v-if="isMedkonDisable" class="alert alert-danger mt-3">
              <center>
                <strong>Data Tidak Tersedia !</strong>
                <p>
                  Aktifkan Channel Media Konvensional untuk Melihat Data Tren
                  Media Konvensional
                </p>
              </center>
            </div>
            <div v-else>
              <div v-if="is_mobile" class="row m-t-10">
                <div
                  v-for="(source, index) in data.data_source_list_formed"
                  :key="index"
                  class="col-sm-6 col-xs-12"
                >
                  <score-card-component :title="source.name" class="m-b-10">
                    <loader-component v-if="is_loading" />
                    <span v-else style="color: #000000">
                      <span v-html="source.icon" /> {{ source.value }}
                    </span>
                  </score-card-component>
                </div>
              </div>
              <div v-else class="row m-t-10">
                <div
                  v-for="(source, index) in data.data_source_list_formed"
                  :key="index"
                  class="col-md-12"
                >
                  <div
                    class="row m-b-10 clickable hoverable"
                    @click="goTo(source.id)"
                  >
                    <div
                      class="col-md-1 col-sm-1 col-xs-1"
                      v-html="source.icon"
                    ></div>
                    <div
                      class="col-md-7 col-sm-7 col-xs-7"
                      style="text-transform: capitalize; font-weight: bold"
                    >
                      {{ source.name }}
                    </div>
                    <div
                      class="col-md-4 col-sm-4 col-xs-4"
                      style="text-transform: capitalize; font-weight: bold"
                    >
                      {{ source.value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-9 p-l-0 pl-md-8">
          <h5 class="no-margin">Media Sosial</h5>
          <loader-component v-if="isloading" />
          <div v-else>
            <div v-if="isMedsosDisable" class="alert alert-danger mt-3">
              <center>
                <strong>Data Tidak Tersedia !</strong>
                <p>
                  Aktifkan Channel Media Sosial untuk Melihat Data Tren Media
                  Sosial
                </p>
              </center>
            </div>
            <div v-else>
              <div v-if="is_mobile" class="row m-t-10">
                <div
                  v-for="(source, index) in data.data_source_list"
                  :key="index"
                  class="col-sm-6 col-xs-12"
                >
                  <score-card-component :title="source.name" class="m-b-10">
                    <loader-component v-if="is_loading" />
                    <span v-else style="color: #000000">
                      <span v-html="source.icon" /> {{ source.value }}
                    </span>
                  </score-card-component>
                </div>
              </div>
              <div v-else class="row m-t-10">
                <div
                  v-for="(source, index) in data.data_source_list"
                  :key="index"
                  class="col-md-4 col-sm-4 col-xs-4"
                >
                  <div
                    class="row m-b-10 clickable hoverable"
                    @click="goTo(source.id)"
                  >
                    <div
                      class="col-md-1 col-sm-1 col-xs-1"
                      v-html="source.icon"
                    ></div>
                    <div
                      class="col-md-7 col-sm-7 col-xs-7"
                      style="text-transform: capitalize; font-weight: bold"
                    >
                      {{ source.name }}
                    </div>
                    <div
                      class="col-md-4 col-sm-4 col-xs-4"
                      style="text-transform: capitalize; font-weight: bold"
                    >
                      {{ source.value }}
                    </div>
                  </div>
                </div>
                <div class="clearfix" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "@/views/components/loader.vue";
import score_card from "@/views/components/score_card.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "source_post_count",
  components: {
    "loader-component": loader,
    "score-card-component": score_card,
  },
  data() {
    return {
      media: this.$store.getters.user.project.project_detail.crawler,
    };
  },
  props: {
    data: Object,
    isloading: Boolean,
    is_mobile: Boolean,
  },
  filters: {
    number_format: function (number) {
      return gp.kmbFormatter(number);
    },
  },
  computed: {
    isMedsosDisable() {
      if (
        this.media.facebook.status == 0 &&
        this.media.instagram.status == 0 &&
        this.media.linkedin.status == 0 &&
        this.media.tiktok.status == 0 &&
        this.media.twitter.status == 0 &&
        this.media.youtube.status == 0 &&
        this.media.google.blog_status == 0 &&
        this.media.google.forum_status == 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    isMedkonDisable() {
      if (
        this.media.formed.cetak_status == 0 &&
        this.media.formed.tv_status == 0 &&
        this.media.google.news_status == 0
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    goTo: function (id) {
      let param = {
        sources: btoa(id),
      };
      if ("topic" in this.$route.query) {
        param.topic = this.$route.query.topic;
      }
      this.$router.push({ path: "posts", query: param });
    },
  },
};
</script>